<template>
    <div class="d-inline">
        <button v-if="button =='yes'" :disabled="wait" class="btn btn-outline-info ml-1" @click.prevent="logout()">
            Logout
        </button>
        <a v-else class="nav-link" href="javascript:void(0)" @click.prevent="logout()">{{ label }}</a>
    </div>
</template>

<script>

export default {
    name: "Logout",
    props: ['button'],
    data() {
        return {
            label: 'LOGOUT'
        }
    },
    methods: {
        logout() {
            this.clear()
            this.label = 'Please wait...'
            this.$http.post('/logout').then(() => {
                this.label = "Logged out!"
                localStorage.clear();
                setTimeout(() => (this.$router.push('/login'), 600))
            }).catch(error => {
                this.showError(error)
            })
        },
    }
}
</script>

<style scoped>

</style>